// extracted by mini-css-extract-plugin
export default {"send_part":"send_send_part__uANA4","send":"send_send__YJ59t"};